import api from 'services/api';

export const getLogs = async () => api.get('/wms/changelogs');
